/*
 *
 * Selectors for HandlePayment
 *
 */

import { createSelector } from 'reselect';
const selectHandlePaymentDomain = (state) => state.get('handlePayment');
const selectHandlePayment = () => createSelector(
  selectHandlePaymentDomain,
  (HandlePayment) => HandlePayment,
);

export { selectHandlePayment };



// WEBPACK FOOTER //
// client/containers/HandlePayment/selectors.js